import * as __vanilla_filescope__ from '@vanilla-extract/css/fileScope';
__vanilla_filescope__.setFileScope("src/theme.css.ts", "@paypalcorp/pp-react-theme");
import { createTheme } from '@vanilla-extract/css';
import { tokens } from './themeContract.css';
// @ts-ignore
// import {PAYPAL_TOKENS} from '@paypalcorp/pp-tokens/build/web/theme/paypal/json-tokens'

export const PAYPAL_TOKENS = {
  size: {
    icon: {
      xs: '1.125rem',
      sm: '1.5rem',
      md: '2rem',
      lg: '3rem',
      xl: '4rem'
    },
    pictogram: {
      sm: '6rem',
      md: '8.5rem',
      lg: '10rem'
    },
    circle: {
      xs: '1.5rem',
      sm: '2rem',
      md: '3rem',
      lg: '4rem',
      xl: '6rem'
    },
    tapTarget: {
      sm: '2.75rem',
      default: '3rem',
      lg: '4rem',
      tiny: '2rem',
      xs: '2.5rem'
    },
    pointerWidth: {
      sm: '0.75rem',
      lg: '1rem'
    },
    indicator: {
      xs: '0.1875rem',
      sm: '0.25rem',
      md: '0.375rem',
      lg: '0.5rem'
    },
    field: {
      sm: '3rem',
      lg: '4rem'
    },
    media: {
      xs: '22rem',
      sm: '36rem',
      md: '47rem',
      lg: '64rem',
      xl: '72rem',
      xxl: '90rem'
    }
  },
  space: {
    '0': '0rem',
    '25': '0.125rem',
    '50': '0.25rem',
    '75': '0.375rem',
    '100': '0.5rem',
    '150': '0.75rem',
    '200': '1rem',
    '250': '1.25rem',
    '300': '1.5rem',
    '350': '1.75rem',
    '400': '2rem',
    '450': '2.25rem',
    '500': '2.5rem',
    '600': '3rem',
    '700': '3.5rem',
    '800': '4rem',
    '900': '4.5rem',
    '1000': '5rem',
    '1100': '5.5rem',
    '1200': '6rem',
    tiny: '0.125rem',
    xs: '0.25rem',
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.5rem',
    jumbo: '2rem'
  },
  elevation: {
    level1: {
      yoffset: '0.0625rem',
      opacity: '0.08',
      blur: '0.75rem'
    },
    level2: {
      yoffset: '0.125rem',
      opacity: '0.1',
      blur: '0.875rem'
    },
    level3: {
      yoffset: '0.125rem',
      opacity: '0.1',
      blur: '1.125rem'
    },
    blurCurve: '1',
    blurSlope: '-1',
    blurBase: '0.625rem',
    opacity: '0.15',
    brightenFactor: '0.02',
    verticalOffsetRatio: '1',
    horizontalOffsetRatio: '0'
  },
  motion: {
    timing: {
      x1: '0',
      y1: '0.9',
      x2: '0.3',
      y2: '1'
    },
    duration: {
      hover: '0.10s',
      action: '0.20s',
      arrive: '0.50s',
      depart: '0.30s',
      repeat: '1.30s',
      linger: '7.00s',
      enter: {
        small: '0.20s',
        medium: '0.30s',
        large: '0.50s'
      },
      exit: {
        small: '0.10s',
        medium: '0.20s',
        large: '0.20s'
      },
      move: {
        small: '0.20s',
        medium: '0.50s',
        large: '0.80s'
      },
      loop: {
        backForth: '0.50s',
        standard: '1.30s'
      },
      pause: {
        read: '7.00s',
        reveal: '4.00s'
      }
    },
    easing: {
      enter: {
        small: '0,0,0,1',
        medium: '0.05,0.7,0.1,1',
        large: '0.05,0.7,0.1,1'
      },
      exit: {
        small: '0.3,0,1,1',
        medium: '0.3,0,0.8,0.15',
        large: '0.3,0,0.8,0.15'
      },
      move: {
        small: '0.2,0,0,1',
        medium: '0.2,0,0,1',
        large: '0.2,0,0,1'
      },
      loop: {
        backForth: '0.2,0,0,1',
        standard: '0,0,1,1'
      }
    }
  },
  border: {
    thickness: {
      normal: '0.0625rem',
      emphasis: '0.125rem',
      focus: '0.1875rem',
      focusOutline: '0.375rem'
    },
    radius: {
      tiny: '0.125rem',
      xs: '0.25rem',
      sm: '0.375rem',
      md: '0.5rem',
      lg: '0.75rem',
      xl: '1rem',
      jumbo: '2rem',
      interactive: '50%'
    }
  },
  typography: {
    displayStrong: {
      family: 'PayPalOpen-Bold',
      size: '4rem',
      weight: '700',
      lineHeight: '3.625rem',
      letterSpacing: '-0.04em',
      maxScaleFactor: '1.25'
    },
    displayMedium: {
      family: 'PayPalOpen-Medium',
      size: '4rem',
      weight: '500',
      lineHeight: '3.625rem',
      letterSpacing: '-0.04em',
      maxScaleFactor: '1.25'
    },
    display: {
      family: 'PayPalOpen-Regular',
      size: '4rem',
      weight: '400',
      lineHeight: '3.625rem',
      letterSpacing: '-0.04em',
      maxScaleFactor: '1.25'
    },
    displaySmStrong: {
      family: 'PayPalOpen-Bold',
      size: '2.5rem',
      weight: '700',
      lineHeight: '2.75rem',
      letterSpacing: '0em',
      maxScaleFactor: '1.25'
    },
    displaySmMedium: {
      family: 'PayPalOpen-Medium',
      size: '2.5rem',
      weight: '500',
      lineHeight: '2.75rem',
      letterSpacing: '0em',
      maxScaleFactor: '1.25'
    },
    displaySm: {
      family: 'PayPalOpen-Regular',
      size: '2.5rem',
      weight: '400',
      lineHeight: '2.75rem',
      letterSpacing: '0em',
      maxScaleFactor: '1.25'
    },
    headingLgStrong: {
      family: 'PayPalOpen-Bold',
      size: '2rem',
      weight: '700',
      lineHeight: '2.25rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '1.5'
    },
    headingLgMedium: {
      family: 'PayPalOpen-Medium',
      size: '2rem',
      weight: '500',
      lineHeight: '2.25rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '1.5'
    },
    headingLg: {
      family: 'PayPalOpen-Regular',
      size: '2rem',
      weight: '400',
      lineHeight: '2.25rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '1.5'
    },
    headingSmStrong: {
      family: 'PayPalOpen-Bold',
      size: '1.5rem',
      weight: '700',
      lineHeight: '2rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '1.5'
    },
    headingSmMedium: {
      family: 'PayPalOpen-Medium',
      size: '1.5rem',
      weight: '500',
      lineHeight: '2rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '1.5'
    },
    headingSm: {
      family: 'PayPalOpen-Regular',
      size: '1.5rem',
      weight: '400',
      lineHeight: '2rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '1.5'
    },
    titleStrong: {
      family: 'PayPalOpen-Bold',
      size: '1rem',
      weight: '700',
      lineHeight: '1.25rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    titleMedium: {
      family: 'PayPalOpen-Medium',
      size: '1rem',
      weight: '500',
      lineHeight: '1.25rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    title: {
      family: 'PayPalOpen-Regular',
      size: '1rem',
      weight: '400',
      lineHeight: '1.25rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    bodyStrong: {
      family: 'PayPalOpen-Bold',
      size: '0.875rem',
      weight: '700',
      lineHeight: '1.125rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '2'
    },
    bodyMedium: {
      family: 'PayPalOpen-Medium',
      size: '0.875rem',
      weight: '500',
      lineHeight: '1.125rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '2'
    },
    body: {
      family: 'PayPalOpen-Regular',
      size: '0.875rem',
      weight: '400',
      lineHeight: '1.125rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '2'
    },
    captionStrong: {
      family: 'PayPalOpen-Bold',
      size: '0.75rem',
      weight: '700',
      lineHeight: '1rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    captionMedium: {
      family: 'PayPalOpen-Medium',
      size: '0.75rem',
      weight: '500',
      lineHeight: '1rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    caption: {
      family: 'PayPalOpen-Regular',
      size: '0.75rem',
      weight: '400',
      lineHeight: '1rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    linkLg: {
      family: 'PayPalOpen-Medium',
      size: '0.875rem',
      weight: '500',
      lineHeight: '1.125rem',
      letterSpacing: '-0.02em',
      underline: 'true',
      maxScaleFactor: '2'
    },
    linkSm: {
      family: 'PayPalOpen-Medium',
      size: '0.75rem',
      weight: '500',
      lineHeight: '1rem',
      letterSpacing: '-0.01em',
      underline: 'true',
      maxScaleFactor: '2'
    },
    tagStrong: {
      family: 'PayPalOpen-Bold',
      size: '0.625rem',
      weight: '700',
      lineHeight: '1rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    tagMedium: {
      family: 'PayPalOpen-Medium',
      size: '0.625rem',
      weight: '500',
      lineHeight: '1rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    tag: {
      family: 'PayPalOpen-Regular',
      size: '0.625rem',
      weight: '400',
      lineHeight: '1rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    dataVizStrong: {
      family: 'PayPalOpen-Bold',
      size: '0.625rem',
      weight: '700',
      lineHeight: '0.75rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    dataVizMedium: {
      family: 'PayPalOpen-Medium',
      size: '0.625rem',
      weight: '500',
      lineHeight: '0.75rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    dataViz: {
      family: 'PayPalOpen-Regular',
      size: '0.625rem',
      weight: '400',
      lineHeight: '0.75rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    buttonLg: {
      family: 'PayPalOpen-Medium',
      size: '0.875rem',
      weight: '500',
      lineHeight: '1.125rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '2'
    },
    buttonSm: {
      family: 'PayPalOpen-Medium',
      size: '0.75rem',
      weight: '500',
      lineHeight: '1rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    fieldLabelLg: {
      family: 'PayPalOpen-Regular',
      size: '0.875rem',
      weight: '400',
      lineHeight: '1.5rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '2'
    },
    fieldLabelSm: {
      family: 'PayPalOpen-Regular',
      size: '0.75rem',
      weight: '400',
      lineHeight: '1.25rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    fieldValueXl: {
      family: 'PayPalOpen-Regular',
      size: '2.5rem',
      weight: '400',
      lineHeight: '2.75rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '1.5'
    },
    fieldValueLg: {
      family: 'PayPalOpen-Regular',
      size: '1.5rem',
      weight: '400',
      lineHeight: '2rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '2'
    },
    fieldValueSm: {
      family: 'PayPalOpen-Regular',
      size: '0.875rem',
      weight: '400',
      lineHeight: '1.5rem',
      letterSpacing: '-0.02em',
      maxScaleFactor: '2'
    },
    navigationBarStrong: {
      family: 'PayPalOpen-Bold',
      size: '0.625rem',
      weight: '700',
      lineHeight: '0.75rem',
      letterSpacing: '0.03em',
      maxScaleFactor: '2'
    },
    navigationBarMedium: {
      family: 'PayPalOpen-Medium',
      size: '0.625rem',
      weight: '500',
      lineHeight: '0.75rem',
      letterSpacing: '0.03em',
      maxScaleFactor: '2'
    },
    navigationBar: {
      family: 'PayPalOpen-Regular',
      size: '0.625rem',
      weight: '400',
      lineHeight: '0.75rem',
      letterSpacing: '0.03em',
      maxScaleFactor: '2'
    },
    legalStrong: {
      family: 'PayPalOpen-Bold',
      size: '0.75rem',
      weight: '700',
      lineHeight: '1rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    legalMedium: {
      family: 'PayPalOpen-Medium',
      size: '0.75rem',
      weight: '500',
      lineHeight: '1rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    },
    legal: {
      family: 'PayPalOpen-Regular',
      size: '0.75rem',
      weight: '400',
      lineHeight: '1rem',
      letterSpacing: '-0.01em',
      maxScaleFactor: '2'
    }
  },
  blur: {
    interactive: '0.5rem'
  },
  color: {
    background: {
      main: '#f0f2f9',
      alt: '#f5f7fb',
      surface: '#ffffff',
      surfaceHover: '#f5f7fb',
      surfaceActive: '#f0f2f9',
      highContrast: '#000000',
      mediumContrast: '#686a6d'
    },
    primary: {
      main: '#0551b5',
      mainHover: '#1161ca',
      mainActive: '#003087',
      contrast: '#ffffff',
      contrastHover: '#aed7ff',
      contrastActive: '#73b9ff'
    },
    secondary: {
      main: '#0070e0',
      mainHover: '#73b9ff',
      mainActive: '#003087',
      contrast: '#ffffff'
    },
    tertiary: {
      main: '#003087',
      mainHover: '#f0f2f9',
      mainActive: '#bcc1c7',
      contrast: '#ddeeff',
      contrastHover: '#f0f2f9',
      contrastActive: '#bcc1c7'
    },
    featured: {
      main: '#ffd140',
      mainHover: '#ffdf7b',
      mainActive: '#f1b700',
      contrast: '#003087'
    },
    promotion: {
      main: '#0070e0',
      mainHover: '#73b9ff',
      mainActive: '#0551b5',
      contrast: '#ffffff',
      medium: {
        main: '#aed7ff',
        mainHover: '#ddeeff',
        mainActive: '#73b9ff',
        contrast: '#0551b5'
      },
      light: {
        main: '#ddeeff',
        mainHover: '#aed7ff',
        mainActive: '#73b9ff',
        contrast: '#0551b5'
      },
      moderate: {
        main: '#aed7ff',
        mainHover: '#ddeeff',
        mainActive: '#73b9ff',
        contrast: '#0551b5'
      },
      soft: {
        main: '#ddeeff',
        mainHover: '#aed7ff',
        mainActive: '#73b9ff',
        contrast: '#0551b5'
      }
    },
    unselected: {
      main: '#bcc1c7',
      mainHover: '#f0f2f9',
      mainActive: '#9199a0',
      contrast: '#4c4d4d'
    },
    selected: {
      main: '#000000',
      mainHover: '#73b9ff',
      mainActive: '#003087',
      alt: '#1161ca',
      altHover: '#73b9ff',
      altActive: '#003087',
      contrast: '#ffffff'
    },
    selectedRange: {
      main: '#aed7ff',
      mainHover: '#73b9ff',
      mainActive: '#1161ca',
      contrast: '#003087'
    },
    link: {
      main: '#1161ca',
      mainHover: '#1161ca',
      mainActive: '#003087',
      contrast: '#ffffff',
      contrastHover: '#aed7ff',
      contrastActive: '#73b9ff',
      alt: '#545d68',
      altHover: '#545d68',
      altActive: '#001435'
    },
    overlay: {
      main: 'rgba(5, 5, 6, 0.55)',
      mainHover: 'rgba(5, 5, 6, 0.4)',
      mainActive: 'rgba(5, 5, 6, 0.7)',
      contrast: '#ffffff'
    },
    overlayInverse: {
      main: 'rgba(255, 255, 255, 0.7)',
      mainHover: 'rgba(255, 255, 255, 0.04)',
      mainActive: 'rgba(255, 255, 255, 0.1)',
      contrast: '#000000'
    },
    accent1: {
      main: '#1161ca',
      contrast: '#ffffff'
    },
    accent2: {
      main: '#e02d50',
      contrast: '#ffffff'
    },
    accent3: {
      main: '#388c00',
      contrast: '#ffffff'
    },
    accent4: {
      main: '#7252cc',
      contrast: '#ffffff'
    },
    error: {
      main: '#d50102',
      mainHover: '#fe7575',
      mainActive: '#870101',
      contrast: '#ffffff',
      medium: {
        main: '#ffe8ec',
        mainHover: '#ff9caa',
        mainActive: '#ff5a6d',
        contrast: '#d50102'
      }
    },
    warning: {
      main: '#ffbe4a',
      mainHover: '#ffdf7b',
      mainActive: '#c07600',
      alt: '#c07600',
      contrast: '#0a0a0a',
      medium: {
        main: '#ffeec2',
        mainHover: '#ffdf7b',
        mainActive: '#ffd140',
        contrast: '#a35441'
      }
    },
    success: {
      main: '#0c6e11',
      mainHover: '#8fd01d',
      mainActive: '#0a570d',
      contrast: '#ffffff',
      medium: {
        main: '#e6f8e7',
        mainHover: '#94df98',
        mainActive: '#42c25b',
        contrast: '#0c6e11'
      }
    },
    system: {
      main: '#001435',
      mainHover: '#9198a0',
      mainActive: '#545d68',
      contrast: '#ffffff'
    },
    info: {
      main: '#cfd3d8',
      mainHover: '#f1f2f3',
      mainActive: '#b2b7bd',
      contrast: '#001435'
    },
    specialty: {
      main: '#7252cc',
      mainHover: '#977fd9',
      mainActive: '#5b38bf',
      contrast: '#ffffff',
      medium: {
        main: '#ede9f9',
        mainHover: '#977fd9',
        mainActive: '#7252cc',
        contrast: '#5b38bf'
      }
    },
    structure: {
      borderHighContrast: '#737b84',
      borderLowContrast: '#cfd3d8',
      divider: 'rgba(5, 5, 6, 0.1)',
      focus: '#097ff5',
      scrim: 'rgba(5, 5, 6, 0.4)',
      shimmer: '#f0f2f9',
      shimmerInverse: '#545d68',
      sheen: 'rgba(255, 255, 255, 0.7)',
      shadow: '#000000',
      focusOutline: 'rgba(209, 229, 249, 0.9)',
      errorOutline: 'rgba(224, 45, 80, 0.16)'
    }
  }
};
export const PAYPAL_THEME = createTheme(tokens, PAYPAL_TOKENS, 'ppui_theme_tokens');
__vanilla_filescope__.endFileScope();
